import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitLead = (data) => api.post("/leads", data).then((r) => r.data);

export const adminLogin = (username, password) =>
  api.post("/admin/login", { username, password }).then((r) => r.data);

export const fetchLeads = (token) =>
  api.get("/admin/leads", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const updateLeadStatus = (token, id, status) =>
  api
    .patch(`/admin/leads/${id}?status=${encodeURIComponent(status)}`, null, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((r) => r.data);

// Static-hosted brochure (client-provided PDF)
export const brochureUrl = "/brochure/CrewConnect-FinInvesto-Brochure.pdf";
